import { render } from "./dpp-photonew.vue?vue&type=template&id=24c8692b"
import script from "./dpp-photonew.js?vue&type=script&lang=js"
export * from "./dpp-photonew.js?vue&type=script&lang=js"

import "./dpp-photonew.vue?vue&type=style&index=0&id=24c8692b&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__